import { Alert, Collapse, useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';
import { useHoldLoginColumn } from '../login-column/use-hold-login-column';

type AuthErrorAlertProps = {
  error: string | null;
};

export const AuthErrorAlert = ({ error }: AuthErrorAlertProps) => {
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const [closed, setClosed] = useState(!error);
  if (error && closed) setClosed(false);
  useHoldLoginColumn(!closed);
  const lastError = useRef(error);
  if (error) lastError.current = error;

  return (
    <Collapse
      in={!!error}
      timeout={reduceMotion ? 0 : 'auto'}
      unmountOnExit
      onExited={() => setClosed(true)}
      sx={{ alignSelf: 'stretch' }}
    >
      <Alert severity="error" sx={{ mb: 1 }}>
        {lastError.current}
      </Alert>
    </Collapse>
  );
};
